import http from "./http";

/* =========================
   ADD LEADS TO CAMPAIGN
========================= */
export const addCampaignLeads = async ({ campaign_id, lead_ids }) => {
  const res = await http.post("campaign_leads?action=add", {
    campaign_id,
    lead_ids
  }, {
    headers: { "Content-Type": "application/json" }
  });
  return res.data;
};

/* =========================
   GET CAMPAIGN LEADS
========================= */
export const getCampaignLeads = async (campaign_id) => {
  const res = await http.get(`campaign_leads?action=list&campaign_id=${campaign_id}`);
  return res.data;
};

/* =========================
   REMOVE LEADS FROM CAMPAIGN
========================= */
export const removeCampaignLeads = async (campaign_id, lead_ids) => {
  const res = await http.post("campaign_leads?action=remove", {
    campaign_id,
    lead_ids
  }, {
    headers: { "Content-Type": "application/json" }
  });
  return res.data;
};